<template>
  <div class="question__answer-item question__image" @click="!buttonVote && onSelectedAnswer(answer)">
    <!-- nosem -->
    <h4 v-if="answer.headline" v-html="answer.headline"></h4>
    <img v-if="buttonVote" class="question__answer-item-image" :src="answer.value" alt="" />
    <img v-else class="question__answer-item-image" :src="answer.value" alt="" />
    <AnswerTooltip v-if="answer.paused">{{ tooltip }}</AnswerTooltip>
    <!-- nosem -->
    <h4 v-if="answer.headline2" v-html="answer.headline2"></h4>
    <!-- nosem -->
    <div v-if="answer.description" class="question__answer-item-description" v-html="answer.description"></div>
    <div v-if="buttonVote" class="content">
      <div class="content__item content__item--action">
        <UIButton class="btn-multiple" @click="onSelectedAnswer(answer)">
          <span v-if="answer.buttonLabel" class="content__item-action-text content__item-action-enabled-text">
            <RichTextRenderer :html="answer.buttonLabel" tag="span" />
          </span>
        </UIButton>
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import AnswerTooltip from './AnswerItemTooltip.vue';
import type { GamePollAnswerState } from '@/src/components/games/poll/Model';
import RichTextRenderer from '@/src/components/RichTextRenderer.vue';
import UIButton from '@/src/components/ui/UIButton.vue';

export default defineComponent({
  name: 'AnswerImageItem',
  components: { UIButton, RichTextRenderer, AnswerTooltip },
  props: {
    answer: {
      type: Object as PropType<GamePollAnswerState>,
      required: true
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    buttonVote: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String
    }
  },
  emits: ['selectedAnswer'],
  setup(props, context) {
    const onSelectedAnswer = (answer: GamePollAnswerState) => {
      if (!props.answer.paused) {
        context.emit('selectedAnswer', answer);
      }
    };

    return {
      onSelectedAnswer
    };
  }
});
</script>
